
<div class="py-3" (keydown.enter)="Search()">
    <div class="formgrid grid">
        <div class="field col-8">
            <input type="text" pInputText [(ngModel)]="barcodeValue" placeholder="Barcode" class="p-inputtext-sm w-full"/>
        </div>
        <div *ngIf="!showScanner" class="field col-4">
            <p-button (click)="OpenScanner()" label="Scan"></p-button>
        </div>
        <div *ngIf="showScanner" class="field col-4">
            <p-button (click)="CloseScanner()" styleClass="p-button-secondary" label="Cancel"></p-button>
        </div>
        <div *ngIf="scannerLoading" class="flex-1 p-4 col-12">
            <p-progressSpinner></p-progressSpinner>
        </div>
        <barcode-scanner-livestream [hidden]="!showScanner" type="code_128" (valueChanges)="onValueChanges($event)" (started)="onStarted($event)" class="col-12">
        </barcode-scanner-livestream>
        <div class="field col-6">
            <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="startDate" placeholder="Start Date" class="p-inputtext-sm" appendTo="body"></p-calendar>
        </div>
        <div class="field col-6">
            <p-calendar [touchUI]="true" [readonlyInput]="true" [(ngModel)]="endDate" placeholder="End Date" class="p-inputtext-sm" appendTo="body"></p-calendar>
        </div>
        <div class="col-6 text-right">
            <p-button [disabled]="!ClearEnabled()" label="Clear" (click)="Clear()" styleClass="p-button-secondary"></p-button>
        </div>
        <div class="col-6 text-left">
            <p-button label="Search" (click)="Search()"></p-button>
        </div>
    </div>
</div>
<p-table [value]="worklists" [loading]="loading">
    <ng-template pTemplate="body" let-worklist>
        <tr (click)="openWorklist(worklist)">
            <td>
                <div class="formgrid grid">
                    <div class="col-11">
                        <div class="formgrid grid">
                            <div class="col-12">
                                {{ worklist.name}}
                            </div>
                            <div class="col-12">
                                <small>{{ worklist.dateCreated | date:'short'}}</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-1">
                        <div class="h-full">
                            <i class="pi pi-chevron-right"></i>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>